// extracted by mini-css-extract-plugin
module.exports = {"ad_wrap":"ad_wrap-3ukRuL4b","space10":"space10-348qKRCW"};